'use client'

import { useState } from 'react'

import { BannerItemType } from '@/components/Homepage/_components/types'
import { Button } from '@/ui/button/Button'

type BannerButtonProps = {
  children: React.ReactNode
  data: BannerItemType
}

const BannerButton = ({ children, data }: BannerButtonProps) => {
  const [isHover, setIsHover] = useState(false)

  return (
    <Button
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      size="lg"
      asChild
      className={`px-[33.5px] text-[16px]`}
      style={{
        backgroundColor: isHover
          ? data?.button_background_hover_color
          : data?.button_background_color,
        color: isHover ? data?.button_text_hover_color : data?.button_text_color,
      }}>
      {children}
    </Button>
  )
}

export { BannerButton }
